/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 15/05/2025 13:51
 *
 */

import {
  Component,
  input,
  linkedSignal,
  output,
  signal,
  ViewChild,
} from '@angular/core';

import { ActionType, DialogMobileAction } from '@infodata-group/inf-commons';
import { DialogComponent } from '@infodata-group/inf-commons-mobile';
import { DrawingHistory } from '../../types/drawing/drawing-history.type';
import { DrawingComponent } from '../drawing/drawing.component';

const DELETE_ACTION = new DialogMobileAction(
  'delete',
  'trash-alt',
  'Supprimer',
  ActionType.danger,
);

@Component({
  selector: 'infl-signature',
  standalone: true,
  imports: [DrawingComponent, DialogComponent],
  templateUrl: './signature.component.html',
  styleUrl: './signature.component.scss',
})
export class SignatureComponent {
  public readonly dialogActions = signal([DELETE_ACTION]);

  public label = input<string>('');
  public height = input<number>(300);
  public color = input<string>('#2A5CA0');
  public showDeleteButton = input<boolean>(true);
  public defaultValue = input<string>('');

  public defaultSignature = linkedSignal(() => this.defaultValue());

  @ViewChild(DrawingComponent) drawingComponent: DrawingComponent;
  @ViewChild(DialogComponent) dialogComponent: DialogComponent;

  public drawingChange = output<string>();
  public drawingClear = output<void>();

  protected onClickDelete($event: MouseEvent | TouchEvent) {
    $event.stopImmediatePropagation();
    this.dialogComponent.open();
  }

  protected onHistoryChange($event: DrawingHistory) {
    if ($event.map((e) => e.positions).flat().length === 0) {
      return;
    }
    this.drawingChange.emit(this.drawingComponent.getImage());
  }

  protected onActionClickDialog($event: string) {
    switch ($event) {
      case DELETE_ACTION.name:
        this.drawingComponent.clear();
        this.defaultSignature.set('');
        this.drawingClear.emit();
        break;
    }
  }
}
